import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type MemberProfile } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: MemberProfile.Api.InitRequest
  ): Promise<HttpApiResponse<MemberProfile.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/profile`, args),
  submit: (
    apiInfo: ModuleApiInfo,
    args: MemberProfile.Api.SubmitRequest
  ): Promise<HttpApiResponse<MemberProfile.Api.SubmitResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/member/profile`, { ...args, moduleId: apiInfo.baseParams.moduleId }),
  resetPassword: (
    apiInfo: ModuleApiInfo,
    args: MemberProfile.Api.ResetPasswordRequest
  ): Promise<HttpApiResponse<MemberProfile.Api.ResetPasswordResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/member/profile/resetPassword`, args)
};
